import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import {
  mdiChevronUp,
  mdiChevronDown,
  mdiChevronLeft,
  mdiChevronRight,
  mdiCheck,
  mdiCheckCircle,
  mdiClose,
  mdiCloseCircle,
  mdiDotsHorizontal,
  mdiDotsVertical,
  mdiPlusCircle,
  mdiBackspaceOutline,
  mdiShareVariantOutline,
  mdiRefresh,
  mdiMagnify,
  mdiHelpCircle,
  mdiInformationOutline,
  mdiImageOutline,
  mdiCrosshairsGps,
  mdiCartOutline,
  mdiClockOutline,
  mdiMapMarker,
  mdiPhone,
  mdiPencilOutline,
  mdiTuneVerticalVariant,
  mdiCash,
  mdiMap,
  mdiTrashCanOutline,
  mdiStore,
  mdiMotorbike,
  mdiCamera,
  mdiSend,
  mdiSortAscending,
  mdiSortDescending,
  mdiHistory
} from '@mdi/js'

Vue.use(Vuetify)
const darkMediaQuery = window.matchMedia('(prefers-color-scheme: dark)')

export default new Vuetify({
  icons: {
    iconfont: 'mdiSvg',
    values: {
      mdiChevronUp,
      mdiChevronDown,
      mdiChevronLeft,
      mdiChevronRight,
      mdiCheck,
      mdiCheckCircle,
      mdiClose,
      mdiCloseCircle,
      mdiDotsHorizontal,
      mdiDotsVertical,
      mdiPlusCircle,
      mdiBackspaceOutline,
      mdiShareVariantOutline,
      mdiRefresh,
      mdiMagnify,
      mdiHelpCircle,
      mdiInformationOutline,
      mdiImageOutline,
      mdiCrosshairsGps,
      mdiCartOutline,
      mdiClockOutline,
      mdiMapMarker,
      mdiPhone,
      mdiPencilOutline,
      mdiTuneVerticalVariant,
      mdiCash,
      mdiMap,
      mdiTrashCanOutline,
      mdiStore,
      mdiMotorbike,
      mdiCamera,
      mdiSend,
      mdiSortAscending,
      mdiSortDescending,
      mdiHistory
    }
  },
  theme: {
    dark: darkMediaQuery.matches,
    themes: {
      light: {
        primary: '#3261FB',
        // primary: '#212121',

        // custom properties
        background: '#FFFFFF',
        'background-secondary': '#FFFFFF',
        loga: '#002774',
        'loga-secondary': '#f7642d'
      },
      dark: {
        // primary: '#3f51b5',

        // custom properties
        background: '#121212',
        'background-secondary': '#252525',
        loga: '#fff',
        'loga-secondary': '#f7642d'
      }
    },
    options: {
      customProperties: true
    }
  }
})
